// Function to generate gradient colors based on title
import React from "react";

const generateGradient = (title: string) => {
    const colors = [
        ['#667eea', '#764ba2'],
        ['#f093fb', '#f5576c'],
        ['#4facfe', '#00f2fe'],
        ['#43e97b', '#38f9d7'],
        ['#fa709a', '#fee140'],
        ['#a8edea', '#fed6e3'],
        ['#ff9a9e', '#fecfef'],
        ['#ffecd2', '#fcb69f'],
        ['#a18cd1', '#fbc2eb'],
        ['#fad0c4', '#ffd1ff'],
    ];

    const hash = title.split('').reduce((acc, char) => {
        return char.charCodeAt(0) + ((acc << 5) - acc);
    }, 0);

    const index = Math.abs(hash) % colors.length;
    return colors[index];
};

// Component to generate image based on title
export const GeneratedImage: React.FC<{ title: string; className?: string }> = ({title, className}) => {
    const [color1, color2] = generateGradient(title);

    return (
        <div
            className={className}
            style={{
                width: '100%',
                height: '200px',
                background: `linear-gradient(135deg, ${color1} 0%, ${color2} 100%)`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '30px',
                fontWeight: 'bold',
                color: 'white',
                textShadow: '0 2px 4px rgba(0,0,0,0.3)',
                position: 'relative',
                overflow: 'hidden',
            }}
        >
            <div
                style={{
                    position: 'absolute',
                    top: '-20px',
                    right: '-20px',
                    width: '100px',
                    height: '100px',
                    background: 'rgba(255,255,255,0.1)',
                    borderRadius: '50%',
                }}
            />
            <div
                style={{
                    position: 'absolute',
                    bottom: '-30px',
                    left: '-30px',
                    width: '120px',
                    height: '120px',
                    background: 'rgba(255,255,255,0.05)',
                    borderRadius: '50%',
                }}
            />
            <div className={'text-center'}>{title}</div>
        </div>
    );
};